module.exports = __webpack_public_path__ + "static/media/paragard-logo-pwa@3x.a2b16c05.jpg";